import React, { useState, useEffect, useContext } from "react";
import { Section } from "@origin-digital/ods-core";
import { useSearchParams } from "react-router-dom";
import { doSearch, doSearchWithParams } from "../helpers/search";
import { ScreenTemplate } from "./ScreenTemplate";
import {
  SearchResult,
  SearchResults,
} from "../components/Search/SearchResults";
import { AppContext } from "../AppContext";

export const SearchResultsPage = () => {
  const { config } = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const searchTerm = searchParams.get("term")!;

  const [searchResults, setSearchResults] = useState<SearchResult>({
    type: "Searching",
  });
  useEffect(() => {
    (async () => {
      setSearchResults({ type: "Searching" });

      const searchRes = await doSearch(searchTerm, config.env);

      setSearchResults({
        type: "Success",
        data: searchRes,
      });
    })();
  }, [searchTerm]);

  const handleSearch = async (searchUrl: string) => {
    setSearchResults((s) => ({ ...s, type: "Searching" }));

    try {
      const res = await doSearchWithParams(searchUrl, config.env);

      setSearchResults({
        type: "Success",
        data: res,
      });
    } catch (e) {
      console.error(e);
      setSearchResults({ type: "Error" });
    }
  };

  return (
    <ScreenTemplate data-id="search" space="none" searchTerm={searchTerm}>
      <Section paddingY="none">
        <SearchResults
          searchResults={searchResults}
          handleSearch={handleSearch}
        />
      </Section>
    </ScreenTemplate>
  );
};
